// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"acd009ae","180":"91df3865","225":"bc8a008f","331":"1fb126d0","409":"f93b55dd","416":"e140935f","449":"aa3fcc19","455":"e273b353","472":"ab12d276","591":"83b8e4b1","604":"a0a80536","607":"a15e5884","703":"16d1c7f7","782":"8ebdc870","847":"e422ee16"}[chunkId] + ".chunk.js";
};